import React, { createContext, useState, useContext } from 'react';

interface GraphHoverContextType {
  hoverTimestep: number | null;
  setHoverTimestep: (timestep: number | null) => void;
}

const GraphHoverContext = createContext<GraphHoverContextType | undefined>(undefined);

export const GraphHoverProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [hoverTimestep, setHoverTimestep] = useState<number | null>(null);

  return (
    <GraphHoverContext.Provider value={{ hoverTimestep, setHoverTimestep }}>
      {children}
    </GraphHoverContext.Provider>
  );
};

export const useGraphHover = (): GraphHoverContextType => {
  const context = useContext(GraphHoverContext);
  if (context === undefined) {
    throw new Error('useGraphHover must be used within a GraphHoverProvider');
  }
  return context;
};

